import React from "react";
import { EnvironmentOutlined } from "@ant-design/icons";

const RoleBlock = ({
  title,
  fromDate,
  toDate,
  location,
  description,
  highlights,
  relevantTechnologies,
  isLast,
}) => {
  return (
    <div className={!isLast ? "pb-6" : ""}>
      <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="text-base font-bold text-brand-600 dark:text-brand-400 md:text-lg">
          {title}
        </h3>
        <span className="inline-flex w-fit rounded-full bg-ink-100 px-3 py-1 text-xs font-medium text-ink-600 dark:bg-ink-800 dark:text-ink-300 md:text-sm">
          {fromDate} – {toDate}
        </span>
      </div>

      {location && (
        <p className="mb-3 flex items-center text-sm text-ink-500 dark:text-ink-400 md:text-base">
          {location} <EnvironmentOutlined className="ml-1" />
        </p>
      )}

      {description && (
        <p className="mb-4 leading-relaxed text-ink-600 dark:text-ink-300">
          {description}
        </p>
      )}

      {highlights && (
        <div className="mb-4">
          <h4 className="mb-2 text-sm font-semibold uppercase tracking-wide text-ink-500 dark:text-ink-400">
            Highlights
          </h4>
          <ul className="space-y-2 border-l-2 border-brand-200 pl-4 dark:border-brand-800">
            {highlights.map((highlight, index) => (
              <li
                key={index}
                className="leading-relaxed text-ink-700 dark:text-ink-300"
              >
                {typeof highlight === "string" ? highlight : highlight}
              </li>
            ))}
          </ul>
        </div>
      )}

      {relevantTechnologies && (
        <div>
          <h4 className="mb-2 text-sm font-semibold uppercase tracking-wide text-ink-500 dark:text-ink-400">
            Technologies
          </h4>
          <div className="flex flex-wrap gap-2">
            {relevantTechnologies.map((tech, index) => (
              <span key={index} className="tech-pill">
                {tech}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const CompanyExperienceGroup = ({
  companyName,
  companyLogo,
  fromDate,
  toDate,
  roles,
}) => {
  return (
    <article className="resume-card mx-auto" style={{ maxWidth: "950px" }}>
      <div className="mb-6 border-b border-ink-100 pb-5 dark:border-ink-800">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-3">
            <img
              src={companyLogo}
              alt={`${companyName} logo`}
              className="h-10 w-10 shrink-0 rounded-lg object-contain ring-1 ring-ink-100 dark:ring-ink-700"
            />
            <span className="text-base font-medium text-ink-800 dark:text-ink-200 md:text-lg">
              {companyName}
            </span>
          </div>
          <span className="inline-flex w-fit shrink-0 rounded-full bg-brand-50 px-3 py-1 text-xs font-medium text-brand-800 ring-1 ring-brand-200/60 dark:bg-brand-950 dark:text-brand-200 dark:ring-brand-800 md:text-sm">
            {fromDate} – {toDate}
          </span>
        </div>
        <p className="mt-2 pl-[52px] text-sm text-ink-500 dark:text-ink-400">
          {roles.length} roles
        </p>
      </div>

      <div className="space-y-6">
        {roles.map((role, index) => (
          <div
            key={`${role.title}-${role.fromDate}`}
            className={
              index < roles.length - 1
                ? "border-b border-ink-100 pb-6 dark:border-ink-800"
                : ""
            }
          >
            <RoleBlock {...role} isLast={index === roles.length - 1} />
          </div>
        ))}
      </div>
    </article>
  );
};

export default CompanyExperienceGroup;
